import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
import { appDeletePost, appGetAllPost, appUpdatePost } from '../../store/post'
import PostPreview from '../../components/PostPreview/PostPreview'
import { categoryOptions } from '../../common/jsonData'
import { toCamelCase } from '../../utils/Function'

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()
	const post = useSelector(state => state?.postReducer.post)
	//	console.log(post)
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const isloder = useSelector(state => state?.postReducer.isloder)
	const paginate = useSelector(state => state.postReducer.paginate)
	// const isdeleted = useSelector(state => state?.postReducer?.isdeleted)

	const [page, setPage] = useState(params.page || 1)
	const [selectedFilters, setSelectedFilters] = useState({
		hub: null,
		sanstha: null,
		categoryOptions: null,
	})
	const [activeFilters, setActiveFilters] = useState({})

	const fetchPosts = useCallback(
		(extraFilters = {}) => {
			dispatch(
				appGetAllPost({
					page,
					limit: 10,
					sanstha: sansthaId || permissionOfSanstha,
					...extraFilters,
				}),
			)
		},
		[dispatch, page, sansthaId, permissionOfSanstha],
	)

	useEffect(() => {
		fetchPosts(activeFilters)
		navigate(`/post/${page}`)
	}, [page, activeFilters, fetchPosts])

	const handleDeletePost = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Post?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeletePost(id)).then(() => {
					fetchPosts(activeFilters)
				})
			}
		})
	}

	const handleSearch = useCallback(() => {
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (selectedFilters.sanstha) {
			filters.sanstha = selectedFilters.sanstha.value
		}
		if (selectedFilters.categoryOptions) {
			filters.categoryOptions = selectedFilters.categoryOptions.value
		}
		if (selectedFilters.approval_required) {
			filters.approval_required = selectedFilters.approval_required
		}
		setExportFilters(filters)
		setActiveFilters(filters)
		setPage(1)
	}, [selectedFilters])

	const handleacceptPost = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to accept this Post?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willAccept => {
			if (willAccept) {
				dispatch(appUpdatePost({ id, approval_required: false })).then(() => {
					fetchPosts(activeFilters)
				})
			}
		})
	}

	const getAdminRole = (item, hub, sanstha) => {
		if (!item?.user) return 'Super Admin'
		if (hub?.admin === item?.user?._id) return 'Community Admin'
		if (sanstha?.admin === item?.user?._id) return 'Sanstha Admin'
		return 'User'
	}

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<label>Category </label>
							<Select
								name="category"
								options={categoryOptions}
								onChange={option => {
									setSelectedFilters(prev => ({
										...prev,
										categoryOptions: option,
									}))
								}}
								value={selectedFilters.categoryOptions}
								placeholder="Select category..."
							/>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label>Filter based on check</label>
								<select
									className="form-control"
									name="approval_required"
									value={
										selectedFilters.approval_required === true
											? 'Pending for approval'
											: selectedFilters.approval_required === false
											? 'All'
											: ''
									}
									onChange={e => {
										const val = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											approval_required:
												val === 'All' ? false : val === 'Pending for approval' ? true : null,
										}))
									}}
								>
									<option value="">Select option</option>
									<option value="All">All</option>
									<option value="Pending for approval"> Pending for Check</option>{' '}
								</select>
							</div>
						</div>

						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										hub: null,
										sanstha: null,
										categoryOptions: null,
									})
									setPage(1)
									setExportFilters({})
									setActiveFilters({})
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>
					</div>

					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Post</th>
									<th>Post Title</th>
									{/* <th>Description </th> */}
									<th>Category </th>
									<th>Community</th>
									<th>Sanstha</th>
									<th>Created Date</th>
									<th>Posted By </th>
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{post.data &&
								post.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<PostPreview value={value} />

												<td
													style={{
														maxWidth: '150px',
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														textTransform: 'capitalize',
													}}
												>
													{value?.title}
												</td>
												{/* <td>{value.description}</td> */}
												<td>{toCamelCase(value?.category)}</td>
												<td>
													{value?.hub ? (
														<>
															{value.hub.image && <PostPreview value={value.hub.image} />}
															{toCamelCase(value?.hub?.name) || '—'}
														</>
													) : (
														''
													)}
												</td>
												<td>
													{value?.sanstha ? (
														<>
															{value.sanstha.image && <PostPreview value={value.sanstha.image} />}
															<br />
															{toCamelCase(value?.sanstha?.name) || '—'}
														</>
													) : (
														''
													)}
												</td>

												<td>
													{new Date(value.createdAt).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td className="text-center align-middle">
													{value?.user && (
														<>
															<PostPreview value={value.user.profilePic || '/img/user.jpg'} />
															{`${value.user.firstName} ${value.user.lastName}`} <br />{' '}
														</>
													)}
													<small>{getAdminRole(value, value?.hub, value?.sanstha)}</small>
												</td>

												<td>
													{value?.approval_required && (
														<button
															type="button"
															className="btn btn-sm btn-green command-delete ml-1 mr-2"
															data-row-id="10253"
															onClick={() => handleacceptPost(value?._id)}
														>
															<i className="fa fa-check" aria-hidden="true"></i>
														</button>
													)}
													<button
														type="button"
														className="btn btn-sm btn-info mr-2 command-edit"
														data-row-id="10253"
														onClick={() => navigate(`/post/edit/${value?._id}`)}
													>
														<em className="fa fa-edit fa-fw"></em>
													</button>
													<button
														type="button"
														className="btn btn-sm btn-danger command-delete"
														data-row-id="10253"
														onClick={() => handleDeletePost(value?._id)}
													>
														<em className="fa fa-trash fa-fw"></em>
													</button>
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
